import { render } from "./PartnerListTable.vue?vue&type=template&id=7321771d"
import script from "./PartnerListTable.vue?vue&type=script&lang=js"
export * from "./PartnerListTable.vue?vue&type=script&lang=js"

import "@/styles/table.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__